import React from "react";
import { AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Logo } from "@/components/common/Brand";
import { ProudRibbon } from "@/components/common/EuStars";

export function SiteFooter() {
  const { tr, lang } = useLang();
  return (
    <footer className="border-t border-zinc-800/70 bg-zinc-950">
      <div className="mx-auto max-w-6xl px-5 py-10">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <Logo className="h-14" />
          <ProudRibbon text="Proud to be European · Proud to serve the European Nations" />
        </div>
        <p className="mt-4 max-w-2xl text-[13px] leading-relaxed text-zinc-400">{tr.footerNote}</p>
        <div className="mt-3 flex items-start gap-2 text-[12px] text-amber-300/80">
          <AlertTriangle size={14} className="mt-0.5 shrink-0" />
          <span>{tr.footerDisc}</span>
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-zinc-800/70 pt-4 text-[11px] text-zinc-600">
          <span>© {new Date().getFullYear()} {tr.brand}. Regulation (EU) 2022/2065.</span>
          <a href="/my-cases" data-testid="footer-my-cases" className="text-zinc-500 hover:text-zinc-300">
            {{ hu: "Ügyeim", en: "My cases", de: "Meine Fälle", fr: "Mes dossiers", cs: "Moje případy" }[lang] || "My cases"}
          </a>
          <a href="/results" data-testid="footer-results" className="text-zinc-500 hover:text-zinc-300">
            {{ hu: "Eredményeink", en: "Our results", de: "Ergebnisse", fr: "Résultats", cs: "Výsledky" }[lang] || "Our results"}
          </a>
          <a href="/privacy" data-testid="footer-privacy" className="text-zinc-500 hover:text-zinc-300">
            {{ hu: "Adatvédelem", en: "Privacy Policy", de: "Datenschutz", fr: "Confidentialité" }[lang] || "Privacy Policy"}
          </a>
          <a href="/terms" data-testid="footer-terms" className="text-zinc-500 hover:text-zinc-300">
            {{ hu: "Felhasználási feltételek", en: "Terms of Service", de: "Nutzungsbedingungen", fr: "Conditions d'utilisation" }[lang] || "Terms of Service"}
          </a>
        </div>
      </div>
    </footer>
  );
}
